import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import type {
  IconGlyph,
  IconStyle,
} from '@ipfabric/ui-components/Icon/IconGlyph';
import classNames from 'classnames';
import type { FC, ReactNode } from 'react';
import './OverflowMenuButton.css';
import { IconButton } from '@ipfabric/ui-components/IconButton/IconButton';
import type { InteractiveAtomSize } from '@ipfabric/ui-components/utils/InteractiveAtomProps';

export interface OverflowMenuButtonProps {
  active?: boolean;
  children: ReactNode;
  dataTestId?: string;
  icon?: IconGlyph;
  iconStyle?: IconStyle;
  loading?: boolean;
  onClick: () => void;
  size?: InteractiveAtomSize;
  disabled?: boolean;
}

export const OverflowMenuButton: FC<OverflowMenuButtonProps> = (props) => (
  <IconButton
    dataTestId={props.dataTestId}
    disabled={props.disabled}
    icon={props.icon ?? 'fa-ellipsis-h'}
    loading={props.loading}
    onClick={props.onClick}
    pressed={props.active}
    size={props.size}
    type='button'
    variant='outline'
  />
);

export const OverflowMenuButtonLegacy: FC<OverflowMenuButtonProps> = (
  props,
) => {
  const icon = !props.children && !props.icon ? 'fa-ellipsis-h' : props.icon;

  return (
    <button
      className={classNames(
        'overflow-menu-button',
        props.active && 'overflow-menu-button--active',
        !!icon && 'overflow-menu-button--with-icon',
      )}
      onClick={props.onClick}
      type='button'
      disabled={props.disabled}
    >
      {props.loading && (
        <Icon
          className={classNames(
            'overflow-menu-button__icon',
            !!props.children && 'mr-2.5',
          )}
          glyph='fa-spinner'
          size='xs'
          loading={props.loading}
        />
      )}
      {icon && !props.loading && (
        <Icon
          className={classNames(
            'overflow-menu-button__icon',
            !!props.children && 'mr-2.5',
          )}
          glyph={icon}
          iconStyle={props.iconStyle}
          size='xs'
        />
      )}
      {props.children}
      {!icon && (
        <Icon
          className='overflow-menu-button__chevron'
          glyph={props.active ? 'fa-chevron-up' : 'fa-chevron-down'}
          size='xs'
        />
      )}
    </button>
  );
};
